import * as React from "react";
function SvgUserArrowTop(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M31.9 14.9c0-7-5.7-12.7-12.6-12.7S6.6 7.9 6.6 14.9c0 5.1 3.1 9.7 7.9 11.6C5.8 28.2 0 35.1 0 44.6v1.2h12.1v-2.4H2.7c.5-8.9 6.9-14.8 16.1-14.8 4 0 8.3 2.3 11.1 4.4l1.5-1.9c-2.4-1.8-5.2-3.3-8.2-4.1 5.1-1.8 8.7-6.6 8.7-12.1zM19.3 25.1c-5.7 0-10.2-4.5-10.3-10.2C9 9.2 13.6 4.7 19.2 4.7c5.7 0 10.2 4.6 10.2 10.2.1 5.6-4.5 10.1-10.1 10.2zm28.7 1v10.5c0 .6-.5 1.2-1.2 1.2s-1.2-.5-1.2-1.2V29L34.9 39.7c-.2.2-.5.4-.8.4-.7 0-1.2-.5-1.2-1.2 0-.4.1-.6.4-.8L44 27.3h-7.7c-.7 0-1.2-.5-1.2-1.2s.5-1.2 1.2-1.2h10.5c.7-.1 1.2.4 1.2 1.2z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgUserArrowTop);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
